import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-hot-toast'
import { AdminUserService } from '@/shared/api'
import type { RoleUpdateRequest } from '@/shared/api'

/**
 * Смена типа курьера (роль 2 — свой, 21 — сторонний).
 * После успеха инвалидируем детали/список курьеров и список модерации.
 */
export function useUpdateUserRole() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ userId, request }: { userId: number; request: RoleUpdateRequest }) =>
      AdminUserService.updateUserRole(userId, request),
    onSuccess: (response) => {
      toast.success(response.message || 'Тип курьера обновлен')

      // Детали и список пользователей/курьеров (['users', ...])
      queryClient.invalidateQueries({ queryKey: ['users'] })
      // Список курьеров на модерации
      queryClient.invalidateQueries({ queryKey: ['couriers'] })
    },
    onError: (error: any) => {
      if (!error?.alreadyToasted) {
        toast.error(error.detail || 'Ошибка смены типа курьера')
      }
    },
  })
}
